module.exports = __webpack_public_path__ + "static/media/7_1.01613bb2.png";